import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputFile } from '../../models/input-file.interface';

@Component({
  selector: 'app-modal-file-list',
  templateUrl: './modal-file-list.component.html'
})
export class ModalFileListComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      files: Array<InputFile>
    }
  ) {}

  openFile(fileUrl: string): void {
    window.open(fileUrl, '_blank');
  }
}
